(() => {
  'use strict';

  const carouselSelector = '.ProductList--carousel, [data-flickity-config], .swiper';
  const mobileQuery = window.matchMedia('(max-width: 640px)');

  const syncGalleryWidth = (swiper) => {
    // Measure the shared image box, unaffected by hover scaling or a hidden gallery.
    const imageWrapper = swiper.el.closest('.ProductItem__ImageWrapper');
    const width = imageWrapper.getBoundingClientRect().width;
    if (width > 0) swiper.params.width = width;
  };

  const enableCardHover = (card, inCarousel) => {
    const imageBox = card.querySelector('.ProductItem__ImageWrapper > .AspectRatio');
    if (!imageBox) return;

    let alternate = imageBox.querySelector(':scope > .ProductItem__Image--mediaAlternate');
    if (!alternate) {
      // Reuse the shared model-image selection without enabling an inner swipe gallery.
      const galleryAlternate = imageBox.querySelector('.ProductItem__MobileGallery .ProductItem__Image--mediaAlternate');
      const mediaTemplates = [
        ...card.querySelectorAll('template[data-product-card-media-template]'),
        ...(card.closest('.Carousel__Cell')?.querySelectorAll(':scope > template[data-product-card-media-template]') || []),
      ];
      const mediaTemplate = mediaTemplates.find(template => template.dataset.productCardMediaTemplate === card.dataset.handle);
      const source = galleryAlternate || (inCarousel && mediaTemplate?.content.querySelector('img'));
      if (!source) return;
      alternate = source.cloneNode(true);
      alternate.classList.add('ProductItem__Image--alternate');
      imageBox.prepend(alternate);
    }
    if (inCarousel) alternate.classList.add('ProductItem__Image--alternate');
    card.classList.add('ProductItem__ImageWrapper--withAlternateImage');
  };

  const initialiseCard = (card) => {
    const inCarousel = Boolean(card.closest(carouselSelector));
    card.dataset.productCardMediaMode = inCarousel ? 'carousel' : 'gallery';
    enableCardHover(card, inCarousel);

    card.querySelectorAll('.ProductItem__Wrapper .swiper').forEach((gallery) => {
      const mobileOnly = gallery.hasAttribute('data-product-card-mobile-gallery');

      // The outer product carousel owns horizontal gestures over the whole card.
      if (inCarousel) {
        if (gallery.swiper && !gallery.swiper.destroyed) {
          gallery.swiper.destroy(true, true);
        }
        gallery.parentElement.classList.remove('AspectRatio--mobileSwipeReady');
        return;
      }

      if (gallery.swiper && !gallery.swiper.destroyed) return;
      if (mobileOnly && !mobileQuery.matches) return;
      if (typeof window.Swiper !== 'function') return;

      const options = {
        // Separate adjacent image layers at fractional device-pixel boundaries.
        spaceBetween: 1,
        ...(mobileOnly ? { nested: true } : {}),
        ...(gallery.closest('#Search') ? {
          focusableElements: 'input:not(.Search__Input), select, option, textarea, button, video, label',
        } : {}),
        on: {
          beforeInit: syncGalleryWidth,
          beforeResize: syncGalleryWidth,
        },
      };
      const pagination = gallery.querySelector('.ProductItem__MobilePagination');
      if (pagination) {
        options.pagination = {
          el: pagination,
          bulletClass: 'ProductItem__MobilePaginationDot',
          bulletActiveClass: 'is-active',
        };
      }

      new window.Swiper(gallery, options);
      if (mobileOnly) {
        gallery.parentElement.classList.add('AspectRatio--mobileSwipeReady');
      }
    });
  };

  window.initProductCardMedia = (root = document) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('.ProductItem')) initialiseCard(root);
    root.querySelectorAll('.ProductItem').forEach(initialiseCard);
  };

  const start = () => {
    window.initProductCardMedia();
    // Recommendations and filtered grids can insert ordinary cards after page load.
    new MutationObserver((records) => {
      records.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => window.initProductCardMedia(node));
      });
    }).observe(document.body, { childList: true, subtree: true });
    mobileQuery.addEventListener('change', () => window.initProductCardMedia());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
